export default __webpack_public_path__ + "static/media/close_slider.55ee0ced.svg";